// Liefert den zu sendenden, getrimmten Namen — oder null, wenn nichts zu tun ist.
export function normalizeRename(draft: string, current: string): string | null {
  const next = draft.trim();
  if (next.length === 0 || next === current) return null;
  return next;
}
